import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { Selector } from '@ngxs/store';
import { DreamboxStateModel } from './dreambox-state.model';
import { DreamboxState } from './dreambox.state';

export class DreamboxSelectors {
  @Selector([DreamboxState])
  static images(state: DreamboxStateModel): ImagePreview[] | undefined {
    return state.images;
  }

  @Selector([DreamboxState])
  static totalCount(state: DreamboxStateModel): number | undefined {
    return state.totalCount;
  }

  @Selector([DreamboxState])
  static hasMoreResults(state: DreamboxStateModel): boolean {
    return (state?.images?.length || 0) < (state?.totalCount || 0);
  }
}
